import React from 'react';
import { Card, H3, Tag, Intent } from '@blueprintjs/core';

function TeamMakerCard({ team, teamLetter, pickOrder, showPickOrder, isAnimating }) {
  if (!team) return null;
  
  const teamAverage = Math.round((team.player1.elo + team.player2.elo) / 2);
  
  return (
    <Card
      className={`team-maker-card ${isAnimating ? 'animating' : ''}`}
      style={{
        padding: '1.5rem',
        background: 'linear-gradient(135deg, var(--bg-secondary), var(--bg-tertiary))',
        border: '1px solid var(--border)',
        position: 'relative',
        minHeight: '200px',
        transition: 'all 0.3s ease'
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
        <H3 style={{ margin: 0, color: 'var(--accent-primary)' }}>
          Team {teamLetter}
        </H3>
        {showPickOrder && pickOrder && (
          <div 
            className={`pick-order-badge ${isAnimating ? 'spin-in' : ''}`}
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: 'var(--accent-primary)',
              color: 'var(--bg-primary)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '1.2rem',
              boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
            }}
          >
            {pickOrder}
          </div>
        )}
      </div>
      
      <div style={{ marginBottom: '1rem' }}>
        <div style={{ 
          padding: '0.75rem', 
          background: 'var(--bg-primary)', 
          borderRadius: 'var(--radius)',
          marginBottom: '0.5rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <span style={{ fontWeight: 500 }}>{team.player1.name || 'Player 1'}</span>
          <Tag intent={Intent.PRIMARY} minimal>
            {team.player1.elo} ELO
          </Tag>
        </div>
        
        <div style={{ 
          padding: '0.75rem', 
          background: 'var(--bg-primary)', 
          borderRadius: 'var(--radius)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <span style={{ fontWeight: 500 }}>{team.player2.name || 'Player 2'}</span>
          <Tag intent={Intent.PRIMARY} minimal>
            {team.player2.elo} ELO
          </Tag>
        </div>
      </div>
      
      <div style={{ 
        borderTop: '1px solid var(--border)', 
        paddingTop: '0.75rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <span style={{ fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
          Team Average:
        </span>
        <Tag intent={Intent.SUCCESS} large>
          {teamAverage} ELO
        </Tag>
      </div>
      
      {showPickOrder && pickOrder && (
        <div style={{
          marginTop: '0.75rem',
          textAlign: 'center',
          fontSize: '0.85rem',
          color: 'var(--text-secondary)'
        }}>
          Character Pick Order: #{pickOrder}
        </div>
      )}
    </Card>
  );
}

export default TeamMakerCard;